import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { InputComponent } from '@shared/components/input/input.component';

import { AgControlComponent, AgControlComponentParams, noop } from './ag-control.component';

interface AgInputComponentParams extends AgControlComponentParams {
  placeholder?: string;
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, InputComponent, AsyncPipe],
  template: `
    @if (formGroup$ | async) {
      <div [formGroup]="$any(formGroup$ | async)">
        @if (isReady$ | async) {
          <aux-input
            class="w-full"
            [formControl]="formControl"
            [inputClassName]="
              hasError ? 'border-aux-red-dark !rounded ' + controlHeightClass : controlHeightClass
            "
            [placeholder]="placeholder"
            (change)="changeHandler()"
          />
        }
      </div>
    }
  `,
})
export class AgInputComponent extends AgControlComponent {
  params!: AgInputComponentParams;
  protected placeholder = '';

  agInit(params: AgInputComponentParams): void {
    this.params = params;
    this.value = params.value;
    this.placeholder = params.placeholder ?? '';
    this.fieldName = params.colDef?.field;
    this.changeHandler = params.changeHandler ?? noop;
    this.updateView(params);
  }
}
